var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolTipQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.647 5.401C5.656 4.726 5.944 4.168 6.628 4.168C7.132 4.168 7.429 4.438 7.429 5.023C7.429 5.536 7.114 5.752 6.736 6.049C6.358 6.346 5.971 6.715 5.917 7.543V7.966H7.195V7.606C7.285 7.048 7.717 6.796 8.131 6.49C8.536 6.184 8.923 5.806 8.923 4.888C8.923 4.159 8.356 3.052 6.556 3.052C5.17 3.052 4.279 4.042 4.252 5.401H5.647ZM5.782 10H7.276V8.533H5.782V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTipQuestionMark);
export default __webpack_public_path__ + "static/media/toolTipQuestionMark.2e33071a45ae35e0149ef00441aa99da.svg";
export { ForwardRef as ReactComponent };